import { render, staticRenderFns } from "./ShopProductGroupBuyGroup.vue?vue&type=template&id=4205a34f&scoped=true"
import script from "./ShopProductGroupBuyGroup.vue?vue&type=script&lang=js"
export * from "./ShopProductGroupBuyGroup.vue?vue&type=script&lang=js"
import style0 from "./ShopProductGroupBuyGroup.vue?vue&type=style&index=0&id=4205a34f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205a34f",
  null
  
)

export default component.exports